import apiSportsSchools from '@/api/sports-schools'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  isLoading: false,
  sportsSchools: [],
  validationErrors: null,
  isSubmitting: false,
  total: null,
  lastPage: null,
}

export const mutationTypes = {
  getSportSchoolsStart: '[sportsSchools more] getSportSchoolsStart',
  getSportSchoolsSuccess: '[sportsSchools more] getSportSchoolsSuccess',
  getSportSchoolsFailure: '[sportsSchools more] getSportSchoolsFailure',

  sportsSchoolsClear: '[sportsSchools more] clear list',
}

export const actionType = {
  getSportSchools: '[sportsSchools more] getSportSchools',
}

const mutations = {
  [mutationTypes.getSportSchoolsStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getSportSchoolsSuccess](state, payload) {
    if (payload.isAdd) {
      state.sportsSchools = [...state.sportsSchools, ...payload.list]
    } else {
      state.sportsSchools = payload.list
    }

    state.isLoading = false
    state.total = payload.total
    state.lastPage = payload.lastPage
  },

  [mutationTypes.getSportSchoolsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.sportsSchoolsClear](state) {
    state.sportsSchools = []
  },
}

const actions = {
  [actionType.getSportSchools](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)

    context.commit(mutationTypes.getSportSchoolsStart)
    return new Promise((resolve) => {
      apiSportsSchools
        .getSportSchoolsMore(params)
        .then((response) => {
          context.commit(mutationTypes.getSportSchoolsSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getSportSchoolsFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
